import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { useState, useCallback, useEffect } from 'react';
import { shows } from '@/data/shows';

export default function ShowsCarousel() {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [
    Autoplay({ delay: 5000 }),
  ]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    setScrollSnaps(emblaApi.scrollSnapList());
    emblaApi.on('select', onSelect);
    onSelect();
    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi, onSelect]);

  return (
    <section className="py-20 bg-white">
      <div className="container-wide">
        <h2 className="text-center mb-12">
          Select faculty may include cast members from the following shows
        </h2>
        <div className="embla" ref={emblaRef}>
          <div className="embla__container">
            {shows.map((show) => (
              <div
                key={show.id}
                className="embla__slide basis-1/2 md:basis-1/3 lg:basis-1/5 px-2"
              >
                <img
                  src={show.logo}
                  alt={show.name}
                  className="w-full h-auto object-contain max-h-80 mx-auto"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-center gap-2 mt-6">
          {scrollSnaps.map((_, index) => (
            <button
              key={index}
              className={`embla__dot ${index === selectedIndex ? 'embla__dot--selected' : ''}`}
              onClick={() => emblaApi?.scrollTo(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
